export default "__VITE_ASSET__0ih5DNZN__"